import React from 'react';
import SubNewsSkeleton from 'app/components/topNewsModule/subNews/SubNewsSkeleton';
import { Container } from 'app/components/topNewsModule/subNews/subNewsStyles';
import { StepperPlaceholder } from 'app/components/styles/swipeableViews/StepperPlaceholder';
export default function SwipeableNewsListSkeleton(_ref) {
  let {
    numChildren,
    animation
  } = _ref;
  const children = Array.from({
    length: numChildren
  }, (_value, index) => /*#__PURE__*/React.createElement(SubNewsSkeleton, {
    key: "subnews-skeleton-".concat(index),
    animation: animation
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-source-file": "SwipeableNewsListSkeleton.tsx"
  }, children), /*#__PURE__*/React.createElement(StepperPlaceholder, {
    "data-sentry-element": "StepperPlaceholder",
    "data-sentry-source-file": "SwipeableNewsListSkeleton.tsx"
  }));
}